import React, {FunctionComponent, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {CabinetVisitsAPI} from 'services/CabinetVisitsAPI';
import {AppState} from 'store';
import * as UserSelectors from 'store/user/selectors';

const visitsAPI = new CabinetVisitsAPI();

// Mount inside the route's access checks and Suspense boundary, so redirected
// and still-loading private screens do not emit a visit.
export const CabinetVisitTracker: FunctionComponent = ({children}) => {
  const {pathname} = useLocation();
  const userId = useSelector((state: AppState) => {
    const user = UserSelectors.userInfo(state);
    return user ? user.userId : null;
  });

  useEffect(() => {
    if (userId === null) {
      return;
    }

    // Telemetry must not interrupt navigation or retry and duplicate a visit.
    visitsAPI.record(pathname).catch(() => undefined);
  }, [userId, pathname]);

  return <>{children}</>;
};
